export const serviceSlugs = ["wind-foundations", "carlisle-membranes", "earthworks"];

export const serviceImages = {
  "wind-foundations":
    "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/sgdtfm4q_WhatsApp%20Image%202026-06-15%20at%2011.46.20.jpeg",
  "carlisle-membranes":
    "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/o1s1gwoq_filtersformatwebpquality75.webp",
  "earthworks":
    "https://images.pexels.com/photos/1078884/pexels-photo-1078884.jpeg?auto=compress&cs=tinysrgb&w=1600",
};

export const serviceGalleries = {
  "wind-foundations": [
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/hsvxgp0o_photo_2026-06-16%2010.39.37.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/kv17c10w_photo_2026-06-16%2010.39.36.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/i03a4uec_photo_2026-06-16%2010.39.28.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/hysbixnp_photo_2026-06-16%2010.39.26.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/zg6ucqun_photo_2026-06-16%2010.39.20.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/4tlfghyh_photo_2026-06-16%2010.40.11.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/bogg8e3w_photo_2026-06-16%2010.40.03.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/6j6qv66w_photo_2026-06-16%2010.39.56.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/obe4ucqb_photo_2026-06-16%2010.39.50.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/7e57t8ia_photo_2026-06-16%2010.39.44.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/gzyz8y6t_photo_2026-06-16%2010.40.20.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/ztbh2e48_photo_2026-06-16%2010.40.29.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
  ],
  "earthworks": [
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/jjxl17ph_photo_2026-06-16%2011.56.01.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/wy4wxh9k_photo_2026-06-16%2011.56.56.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/yuekwa48_photo_2026-06-16%2011.56.58.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/pnrpaqk5_photo_2026-06-16%2011.57.51.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/kdpqljko_photo_2026-06-16%2012.01.48.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/qh4wx2i0_photo_2026-06-16%2012.02.05.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/mld4boss_photo_2026-06-16%2012.02.06.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/wpmgifoc_photo_2026-06-16%2012.02.38.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
  ],
  "carlisle-membranes": [
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/ziy24mpn_photo_2026-06-16%2011.50.48.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/ki19kyu1_photo_2026-06-16%2011.50.59.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/b9d13w8t_photo_2026-06-16%2011.51.02.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/tvh1xtcz_photo_2026-06-16%2011.51.07.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/2gnxaw78_photo_2026-06-16%2011.51.11.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/ccloi45j_photo_2026-06-16%2011.51.12.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/fcq4775n_photo_2026-06-16%2011.50.39.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/ye1m8000_resitrix-sk-partial-bond-liggend.jpg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/xk3wayxw_resitrix-catalog-produse-thumbnail-ro.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/wu7e3sst_resitrix-accessories-green-rolle.jpg",
      caption: { ro: "", en: "", ru: "" },
    },
    {
      src: "https://customer-assets.emergentagent.com/job_castel-new-look/artifacts/vxsk0330_photo_2026-06-16%2013.21.15.jpeg",
      caption: { ro: "", en: "", ru: "" },
    },
  ],
};

export const serviceDetails = {
  ro: {
    "wind-foundations": {
      eyebrow: "01 / Energie eoliană",
      title: "Execuție fundații eoliene",
      intro: "Executăm lucrări de fundații pentru turbine eoliene, oferind soluții complete de la pregătirea terenului până la turnarea finală a betonului.",
      body: "Ne concentrăm pe rezistență structurală, precizie și respectarea celor mai înalte standarde din domeniul construcțiilor energetice.",
      listTitle: "Servicii:",
      bullets: [
        "Pregătire teren și lucrări de terasament",
        "Armare fundații conform proiectului tehnic",
        "Turnare beton de înaltă performanță",
        "Instalare sisteme de fixare și ancorare turbine",
        "Testare și control al calității",
      ],
      outro: null,
    },
    "carlisle-membranes": {
      eyebrow: "02 / Hidroizolații",
      title: "Soluții profesionale pentru acoperișuri plate cu membrane CARLISLE®",
      intro: "Protejați-vă investiția cu sisteme moderne de hidroizolație de la CARLISLE®, unul dintre liderii mondiali în domeniul membranelor pentru acoperișuri plate.",
      body: "Compania noastră oferă furnizare și montaj profesionist al membranelor CARLISLE®, asigurând:",
      listTitle: null,
      bullets: [
        "Etanșeitate și protecție de lungă durată împotriva infiltrațiilor",
        "Rezistență excelentă la razele UV și condițiile climatice extreme",
        "Durată mare de exploatare și costuri reduse de întreținere",
        "Soluții eficiente pentru clădiri industriale, comerciale și rezidențiale",
        "Montaj realizat de specialiști cu experiență",
      ],
      outro: "Indiferent dacă este vorba despre o construcție nouă sau renovarea unui acoperiș existent, vă oferim soluția optimă pentru un acoperiș sigur, durabil și eficient.",
      marketingSection: {
        eyebrow: "EPDM · TPO/FPO",
        leadIntro: "CASTEL CONSTRUCT S.R.L. vă poate oferi cea mai bună membrană globală — EPDM și TPO/FPO.",
        bigQuote: "Epidemia de ermetism: doar Carlisle și Hertalan vă pot oferi o asemenea imunitate.",
        body: [
          "Atenție! Vecinii dumneavoastră care folosesc PVC și beton ar putea deveni invidioși. Urmează epidemia de iazuri impecabile, iar sursa ei sunt standardele industriale mondiale de calitate.",
          "Vă oferim o membrană profesională EPDM, dezvoltată de lideri din industrie — precum Carlisle (SUA) și Hertalan (Europa). Acesta este materialul folosit pentru hidroizolarea celor mai importante obiective din întreaga lume.",
        ],
        whyTitle: "De ce este acesta un virus al fiabilității?",
        whyIntro: "Deoarece membrana EPDM premium elimină toate punctele sensibile ale construcției obișnuite de iazuri:",
        tableHeaders: ["Parametru Premium", "Avantajul Carlisle / Hertalan", "Beneficiul final pentru dumneavoastră"],
        tableRows: [
          { p: "Durabilitate", a: "Termen de exploatare de până la 70 de ani. Garanție de la 20 la 25 de ani.", b: "Un iaz pe viață. Nu va mai trebui să-l reparați." },
          { p: "Ecologie", a: "100% cauciuc inert. Deține certificate de siguranță pentru organismele vii.", b: "Siguranță completă pentru crap Koi, sturioni și întreaga floră acvatică." },
          { p: "Rezistență și grosime", a: "Grosime standard de 1.14 mm.", b: "Protecție împotriva perforărilor. Rezistență la rădăcinile copacilor, pietre și deteriorări mecanice în timpul curățării." },
          { p: "Elasticitate", a: "Rezistă la întindere de până la 500% (de cinci ori).", b: "Membrana nu se rupe și nu crapă la înghețuri extreme (−40°C) și la mișcări ale solului." },
          { p: "Stabilitate UV", a: "Rezistență completă la ultraviolete și ozon.", b: "Estetică fără distrugere. Puteți crea linii de țărm deschise și cascade." },
        ],
        closingTitle: "Alegerea pentru cei care construiesc pentru veacuri",
        closingBody: "Alegând o membrană EPDM care corespunde standardelor Carlisle sau Hertalan, alegeți un nivel industrial de calitate pentru peisajul dumneavoastră personal. Aceasta nu este doar hidroizolare — este fundamentul ecosistemului dumneavoastră acvatic.",
        closingPunch: "Nu vă mulțumiți cu puțin. Alegeți leadership-ul și garanția.",
        ctaText: "Lăsați o cerere astăzi — calculăm proiectul dumneavoastră cu cel mai bun material EPDM și TPO/FPO premium de pe piață.",
      },
    },
    "earthworks": {
      eyebrow: "03 / Terasamente",
      title: "Lucrări de terasament",
      intro: "Executăm lucrări de terasament pentru proiecte rezidențiale, comerciale și industriale. Dispunem de utilaje moderne și personal calificat pentru a realiza lucrările rapid, eficient și în condiții de maximă siguranță.",
      body: null,
      listTitle: "Serviciile noastre:",
      bullets: [
        "Excavații pentru fundații",
        "Săpături pentru rețele de apă, canalizare și cabluri",
        "Nivelarea și pregătirea terenului",
        "Decopertarea stratului vegetal",
        "Umpluturi și compactări",
        "Amenajarea platformelor și drumurilor de acces",
        "Transport și evacuare pământ",
      ],
      outro: null,
    },
  },
  en: {
    "wind-foundations": {
      eyebrow: "01 / Wind energy",
      title: "Wind turbine foundation construction",
      intro: "We carry out foundation works for wind turbines, offering complete solutions from site preparation to the final concrete pour.",
      body: "We focus on structural resistance, precision and compliance with the highest standards in energy construction.",
      listTitle: "Services:",
      bullets: [
        "Site preparation and earthworks",
        "Foundation reinforcement to technical design",
        "High-performance concrete pouring",
        "Installation of turbine fixing and anchoring systems",
        "Quality testing and control",
      ],
      outro: null,
    },
    "carlisle-membranes": {
      eyebrow: "02 / Waterproofing",
      title: "Professional flat roof solutions with CARLISLE® membranes",
      intro: "Protect your investment with modern waterproofing systems from CARLISLE® — one of the world leaders in flat roof membrane technology.",
      body: "Our company provides professional supply and installation of CARLISLE® membranes, ensuring:",
      listTitle: null,
      bullets: [
        "Long-lasting watertightness and leak protection",
        "Excellent resistance to UV rays and extreme weather",
        "Extended service life and reduced maintenance costs",
        "Effective solutions for industrial, commercial and residential buildings",
        "Installation performed by experienced specialists",
      ],
      outro: "Whether new construction or renovation of an existing roof, we offer the optimal solution for a safe, durable and efficient roof.",
      marketingSection: {
        eyebrow: "EPDM · TPO/FPO",
        leadIntro: "CASTEL CONSTRUCT S.R.L. can offer you the world's best membrane — EPDM and TPO/FPO.",
        bigQuote: "The epidemic of airtightness: only Carlisle and Hertalan can give you such immunity.",
        body: [
          "Warning. Your neighbours using PVC and concrete may get jealous. What follows is the epidemic of flawless ponds — sourced from the world's industrial quality standards.",
          "We offer a professional EPDM membrane developed by industry leaders — Carlisle (USA) and Hertalan (Europe). This is the material used to waterproof the most demanding sites worldwide.",
        ],
        whyTitle: "Why is this a virus of reliability?",
        whyIntro: "Because the premium EPDM membrane eliminates every weak point of conventional pond construction:",
        tableHeaders: ["Premium parameter", "Carlisle / Hertalan advantage", "Final benefit for you"],
        tableRows: [
          { p: "Durability", a: "Service life up to 70 years. Warranty 20–25 years.", b: "A pond for life. You won't need to repair it." },
          { p: "Ecology", a: "100% inert rubber. Certified safe for living organisms.", b: "Complete safety for Koi carp, sturgeon and the entire aquatic flora." },
          { p: "Strength & thickness", a: "Standard 1.14 mm thickness.", b: "Puncture protection. Resistant to tree roots, stones and mechanical damage during cleaning." },
          { p: "Elasticity", a: "Withstands up to 500% stretching (fivefold).", b: "The membrane does not tear or crack at extreme cold (−40°C) or with ground movements." },
          { p: "UV stability", a: "Full resistance to ultraviolet rays and ozone.", b: "Aesthetics without degradation. Use it for exposed shorelines and waterfalls." },
        ],
        closingTitle: "The choice for those who build for centuries",
        closingBody: "By choosing an EPDM membrane that meets Carlisle or Hertalan standards, you choose industrial-grade quality for your personal landscape. This isn't just waterproofing — it's the foundation of your aquatic ecosystem.",
        closingPunch: "Don't settle for less. Choose leadership and warranty.",
        ctaText: "Submit a request today — we'll plan your project with the best premium EPDM and TPO/FPO material on the market.",
      },
    },
    "earthworks": {
      eyebrow: "03 / Earthworks",
      title: "Earthworks",
      intro: "We carry out earthworks for residential, commercial and industrial projects. We have modern equipment and qualified personnel to deliver the works quickly, efficiently and safely.",
      body: null,
      listTitle: "Our services:",
      bullets: [
        "Foundation excavation",
        "Trenches for water, sewage and cable networks",
        "Land levelling and preparation",
        "Topsoil removal",
        "Backfilling and compaction",
        "Platforms and access roads",
        "Earth transport and disposal",
      ],
      outro: null,
    },
  },
  ru: {
    "wind-foundations": {
      eyebrow: "01 / Ветроэнергетика",
      title: "Возведение фундаментов под ветрогенераторы",
      intro: "Выполняем работы по устройству фундаментов для ветрогенераторов — полный цикл от подготовки площадки до финальной заливки бетона.",
      body: "Делаем акцент на конструктивной прочности, точности и соблюдении высочайших стандартов в энергетическом строительстве.",
      listTitle: "Услуги:",
      bullets: [
        "Подготовка участка и земляные работы",
        "Армирование фундаментов по техническому проекту",
        "Заливка высокопрочного бетона",
        "Установка систем крепления и анкеровки турбин",
        "Тестирование и контроль качества",
      ],
      outro: null,
    },
    "carlisle-membranes": {
      eyebrow: "02 / Гидроизоляция",
      title: "Профессиональные решения для плоских кровель — мембраны CARLISLE®",
      intro: "Защитите свою инвестицию современными системами гидроизоляции CARLISLE® — одного из мировых лидеров в мембранах для плоских кровель.",
      body: "Наша компания обеспечивает профессиональную поставку и монтаж мембран CARLISLE®, гарантируя:",
      listTitle: null,
      bullets: [
        "Долговечную герметичность и защиту от протечек",
        "Отличную устойчивость к УФ-излучению и экстремальной погоде",
        "Длительный срок службы и низкие затраты на обслуживание",
        "Эффективные решения для промышленных, коммерческих и жилых зданий",
        "Монтаж опытными специалистами",
      ],
      outro: "Будь то новое строительство или ремонт существующей кровли — мы предложим оптимальное решение для безопасной, долговечной и эффективной крыши.",
      marketingSection: {
        eyebrow: "EPDM · TPO/FPO",
        leadIntro: "CASTEL CONSTRUCT S.R.L. может предложить вам лучшую в мире мембрану — EPDM и TPO/FPO.",
        bigQuote: "Эпидемия герметичности: только Carlisle и Hertalan могут дать такой иммунитет.",
        body: [
          "Внимание. Ваши соседи, использующие ПВХ и бетон, могут позавидовать. Дальше — эпидемия безупречных прудов, источник которой — мировые отраслевые стандарты качества.",
          "Мы предлагаем профессиональную EPDM-мембрану от лидеров индустрии — Carlisle (США) и Hertalan (Европа). Этот материал используется для гидроизоляции самых ответственных объектов по всему миру.",
        ],
        whyTitle: "Почему это вирус надёжности?",
        whyIntro: "Потому что премиум EPDM-мембрана устраняет все слабые места обычного устройства пруда:",
        tableHeaders: ["Премиум-параметр", "Преимущество Carlisle / Hertalan", "Итоговая выгода для вас"],
        tableRows: [
          { p: "Долговечность", a: "Срок службы до 70 лет. Гарантия 20–25 лет.", b: "Пруд на всю жизнь. Чинить не придётся." },
          { p: "Экология", a: "100% инертный каучук. Имеет сертификаты безопасности для живых организмов.", b: "Полная безопасность для Кои, осетровых и всей водной флоры." },
          { p: "Прочность и толщина", a: "Стандартная толщина 1,14 мм.", b: "Защита от проколов. Стойкость к корням деревьев, камням и механическим повреждениям при уборке." },
          { p: "Эластичность", a: "Растягивается до 500% (в пять раз).", b: "Мембрана не рвётся и не трескается при экстремальных морозах (−40°C) и подвижках грунта." },
          { p: "UV-стабильность", a: "Полная устойчивость к ультрафиолету и озону.", b: "Эстетика без разрушения. Подходит для открытой береговой линии и водопадов." },
        ],
        closingTitle: "Выбор для тех, кто строит на века",
        closingBody: "Выбирая EPDM-мембрану по стандартам Carlisle или Hertalan, вы выбираете промышленный уровень качества для вашего личного ландшафта. Это не просто гидроизоляция — это основа вашей водной экосистемы.",
        closingPunch: "Не довольствуйтесь малым. Выбирайте лидерство и гарантию.",
        ctaText: "Оставьте заявку сегодня — мы рассчитаем ваш проект с лучшим премиальным EPDM- и TPO/FPO-материалом на рынке.",
      },
    },
    "earthworks": {
      eyebrow: "03 / Земляные работы",
      title: "Земляные работы",
      intro: "Выполняем земляные работы для жилых, коммерческих и промышленных проектов. Располагаем современной техникой и квалифицированным персоналом, чтобы выполнить работы быстро, эффективно и максимально безопасно.",
      body: null,
      listTitle: "Наши услуги:",
      bullets: [
        "Земляные работы под фундамент",
        "Траншеи под сети воды, канализации и кабелей",
        "Планировка и подготовка участка",
        "Снятие плодородного слоя",
        "Засыпка и уплотнение",
        "Устройство площадок и подъездных дорог",
        "Вывоз и утилизация грунта",
      ],
      outro: null,
    },
  },
};

export const serviceDetailUI = {
  ro: { back: "Înapoi la pagina principală", cta: "Solicită ofertă", relatedTitle: "Alte servicii", galleryTitle: "Galerie de proiect" },
  en: { back: "Back to home", cta: "Request a quote", relatedTitle: "Other services", galleryTitle: "Project gallery" },
  ru: { back: "Назад на главную", cta: "Запросить смету", relatedTitle: "Другие услуги", galleryTitle: "Галерея проекта" },
};
